import{
  FETCH_USER_DATA, USER_LOGIN_REQUEST, USER_REGISTRATION_REQUEST,USER_ADDRESSE_REQUEST,USER_LOGOUT
} from '../constants/user'

import user from '../utils/user/'
import localStorage from '../utils/localStorage/'

export function loginUser(data) {
  return (dispatch) => {
    dispatch({
      type   : USER_LOGIN_REQUEST,
      payload: {
        login: {
          data    : null,
          fetching: true,
          isLogin : false,
          message : {
            show: false,
            text: null
          }
        }
      }
    })

    user.loginUser(data).then(d => {
      if (d.isLogin) {

        user.getUser(d.user_id).then(data => {
          localStorage.add('user_id', d.user_id);

          dispatch({
            type   : FETCH_USER_DATA,
            payload: {
              login: {
                data    : data,
                fetching: false,
                isLogin : d.isLogin,
                message : {
                  show: false,
                  text: null
                }
              }
            }
          })
        })
      } else {
        dispatch({
          type   : USER_LOGIN_REQUEST,
          payload: {
            login: {
              data    : null,
              fetching: true,
              isLogin : false,
              message : d.message
            }
          }
        })
      }
    });
  }
}

export function requestLogin() {
  return (dispatch) => {
    if (localStorage.get('user_id')) {
      user.getUser(localStorage.get('user_id')).then(data => {
        dispatch({
          type   : FETCH_USER_DATA,
          payload: {
            login: {
              data    : data,
              fetching: false,
              isLogin : true,
              message : {
                show: false,
                text: null
              }
            }
          }
        })
      })
      user.getAddresse(localStorage.get('user_id')).then(data => {
          dispatch({
            type   : USER_ADDRESSE_REQUEST,
            payload: {
              adresse2:{
                fetching: true,
                data :data,
              }
            }
          })
        })
    }
  }
}

export function registrationUser(data) {
  return (dispatch) => {
    dispatch({
      type   : USER_REGISTRATION_REQUEST,
      payload: {
        registration: {
          fetching: true,
          message : {
            show: false,
            text: null
          }
        }
      }
    })
    user.registration(data).then(d => {
     
      if (d.isLogin) {
        user.getUser(d.user_id).then(data => {
          localStorage.add('user_id', d.user_id);

          dispatch({
            type   : FETCH_USER_DATA,
            payload: {
              login: {
                data    : data,
                fetching: false,
                isLogin : d.isLogin,
                message : {
                  show: false,
                  text: null
                }
              },

            }
          })
        })
      } else {
        dispatch({
          type   : USER_REGISTRATION_REQUEST,
          payload: {
            registration: {
              fetching: false,
              message : d.message
            }
          }
        })
      }
    });
  }
}
export function logoutUser() {
  return (dispatch)=> {
    localStorage.remove('user_id');

    dispatch({
      type   : USER_LOGOUT,
      payload: {
        login       : {
          user_id : null,
          data    : null,
          fetching: true,
          isLogin : false,
          message : {
            show: false,
            text: null
          }
        },
        registration: {
          fetching: false,
          message : {
            show: false,
            text: null
          }
        },
        adresse2:{
          fetching: false,
          data :null,
        }
      }
    })
  }
}

export function forgotUser(data) {
  return (dispatch) => {
    dispatch({
      type   : USER_LOGIN_REQUEST,
      payload: {
        login: {
          data    : null,
          fetching: true,
          check:false,
        }
      }
    })
    user.forgotUsers(data).then(d => {
      
      if (d.forgot !== 0) {
        if (d.email !== "") {
          dispatch({
            type   : FETCH_USER_DATA,
            payload: {
              login: {
                data    : d,
                fetching: false,
                check : 1,
              }
            }
          })
        }else{
          dispatch({
            type   : FETCH_USER_DATA,
            payload: {
              login: {
                data    : d,
                fetching: false,
                check : 3,
              }
            }
          })
        }
      } else {
        dispatch({
          type   : USER_LOGIN_REQUEST,
          payload: {
            login: {
              data    : null,
              fetching: true,
              check : 2,
            }
          }
        })
      }
    });
  }
}
export function ChangePasswordtUser(data) {
  return (dispatch) => {
    dispatch({
      type   : USER_LOGIN_REQUEST,
      payload: {
        login: {
          data    : null,
          fetching: true,
          check:false,
        }
      }
    })
    user.ChangePasswordtUsers(data).then(d => {
      if (d.forgot !== 0) {
          dispatch({
            type   : FETCH_USER_DATA,
            payload: {
              login: {
                data    : d,
                fetching: false,
                check : 1,
              }
            }
          })
      } else {
        dispatch({
          type   : USER_LOGIN_REQUEST,
          payload: {
            login: {
              data    : null,
              fetching: true,
              check : 2,
            }
          }
        })
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/actions/userActions.js